import React from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export function ScoreContainer({ resultObj }) {


    const { mirs_discipline } = useUrlFriendlyToParameters()

    return (
        <>
            <div className='score-result-container justify-content-end d-flex w-30'>
                <div className='text-end fw-bold text-nowrap w-55'>
                    {resultObj?.result}
                </div>
                {resultObj?.hasIRM === true
                    ? <div className='text-start fw-bold w-45 score-irm'>
                        <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true} />
                    </div>
                    : ''}
            </div>
        </>
    )
}